const html = require('choo/html');
const QRCode = require('qrcode');
const { copyToClipboard, resolvePublicShareUrl } = require('../utils');
const { shareWeChatNotice, shareEmailLink } = require('./sharePanelExtras');

module.exports = function(name, url) {
  const dialog = function(state, emit, close) {
    const shareUrl = resolvePublicShareUrl(url, state.baseUrl);
    return html`
      <send-copy-dialog
        class="flex flex-col items-center text-center m-auto w-full"
      >
        <div class="bg-white dark:bg-grey-90 rounded-xl shadow-big p-6 w-full max-w-sm mb-4">
          ${shareWeChatNotice(state)}
          <h1 class="text-3xl font-bold my-4 text-grey-90 dark:text-grey-10">
            ${state.translate('notifyUploadEncryptDone')}
          </h1>
          <p class="font-normal leading-normal text-grey-80 dark:text-grey-40 mb-6">
            ${state.translate('copyLinkDescription')} <br />
            <span class="word-break-all font-bold">${name}</span>
          </p>
          <input
            type="text"
            id="share-url"
            class="w-full mb-6 border rounded-lg leading-loose h-12 px-3 text-grey-80 bg-grey-10 dark:bg-grey-80 dark:text-grey-10 border-grey-30 dark:border-grey-60 focus:border-blue-50 focus:outline-none transition-colors"
            value="${shareUrl}"
            readonly="true"
          />
          
          <div class="w-full flex flex-col items-center">
            <button
              class="btn p-0 rounded-lg w-full min-h-12 py-3 mb-4 focus:outline-none bg-blue-60 hover:bg-blue-70 text-white flex flex-row items-center justify-center transition-colors shadow-sm relative overflow-hidden"
              onclick="${copy}"
              title="${state.translate('copyLinkButton')}"
            >
              <div class="flex items-center justify-center pointer-events-none">
                  <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path></svg>
                  <span class="font-medium text-base leading-none">${state.translate('copyLinkButton')}</span>
              </div>
            </button>

            ${shareEmailLink(state, name, shareUrl, 'mb-4')}

            <button
              class="btn p-0 rounded-lg w-full min-h-12 py-3 focus:outline-none bg-blue-60 hover:bg-blue-70 text-white flex flex-row items-center justify-center transition-colors shadow-sm relative overflow-hidden"
              onclick="${showQrCode}"
              title="${state.translate('scanQrCodeButton')}"
            >
               <div class="flex items-center justify-center pointer-events-none">
                  <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1V4a1 1 0 011-1h3zm-1 3v-1h-1v1h1zM10 10a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm7-1a1 1 0 00-1 1v1h-1v-1a1 1 0 00-2 0v4a1 1 0 001 1h1v1a1 1 0 102 0v-6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                  </svg>
                  <span class="font-medium text-base leading-none">${state.translate('scanQrCodeButton')}</span>
              </div>
            </button>
          </div>
        </div>
        
        <div class="w-full max-w-sm px-0 mx-auto">
          <button
            class="btn p-0 rounded-lg w-full min-h-12 py-3 focus:outline-none bg-blue-60 hover:bg-blue-70 text-white flex flex-row items-center justify-center transition-colors shadow-sm relative overflow-hidden"
            onclick="${close}"
            title="${state.translate('okButton')}"
          >
             <div class="flex items-center justify-center pointer-events-none">
                <span class="font-medium text-base leading-none">${state.translate('okButton')}</span>
             </div>
          </button>
        </div>
      </send-copy-dialog>
    `;

    function copy(event) {
      event.stopPropagation();
      event.preventDefault(); // Prevent any default behavior
      copyToClipboard(shareUrl);
      const btn = event.currentTarget;
      const span = btn.querySelector('span');
      if (span) {
        const originalText = span.textContent;
        // Use translation for 'Copied' if available, or hardcode/reuse existing key
        // Assuming 'copiedUrl' key exists as per previous code
        span.textContent = state.translate('copiedUrl'); 
        
        setTimeout(() => {
            span.textContent = originalText;
            // close(); // REMOVED: Keep the dialog open as per user request
        }, 2000); // Increased to 2s for better visibility
      }
    }

    function showQrCode(event) {
      event.stopPropagation();
      
      const modal = document.createElement('div');
      modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300 opacity-0';
      
      const content = document.createElement('div');
      content.className = 'bg-white dark:bg-grey-90 rounded-xl p-8 flex flex-col items-center shadow-2xl transform scale-95 transition-transform duration-300 w-full max-w-[340px] mx-4';
      
      const title = document.createElement('h3');
      title.className = 'text-2xl font-bold mb-6 dark:text-grey-10';
      title.textContent = state.translate('scanQrCodeButton');
      content.appendChild(title);
      
      const canvas = document.createElement('canvas');
      QRCode.toCanvas(canvas, shareUrl, { width: 220, margin: 1 }, function (error) {
        if (error) console.error(error);
      });
      content.appendChild(canvas);
      
      const tip = document.createElement('p');
      tip.className = 'text-sm text-grey-60 dark:text-grey-40 mt-6 mb-8 text-center';
      tip.textContent = state.translate('qrcodeExpiry');
      content.appendChild(tip);
      
      const btnGroup = document.createElement('div');
      btnGroup.className = 'flex space-x-4 w-full';
      
      const saveBtn = document.createElement('button');
      saveBtn.className = 'flex-1 bg-blue-60 hover:bg-blue-70 text-white font-medium py-3 rounded-lg focus:outline-none transition-colors text-base whitespace-no-wrap shadow-sm';
      saveBtn.textContent = state.translate('saveImage');
      saveBtn.onclick = function() {
        const link = document.createElement('a');
        link.download = 'qrcode.png';
        link.href = canvas.toDataURL();
        link.click();
      };
      btnGroup.appendChild(saveBtn);
      
      const closeBtn = document.createElement('button');
      closeBtn.className = 'flex-1 bg-grey-10 hover:bg-grey-20 text-grey-90 dark:bg-grey-80 dark:hover:bg-grey-70 dark:text-grey-10 font-medium py-3 rounded-lg focus:outline-none transition-colors text-base whitespace-no-wrap shadow-sm';
      closeBtn.textContent = state.translate('closeButton');
      closeBtn.onclick = closeModal;
      btnGroup.appendChild(closeBtn);
      
      content.appendChild(btnGroup);
      modal.appendChild(content);
      document.body.appendChild(modal);
      
      // Trigger animation
      requestAnimationFrame(() => {
        modal.classList.remove('opacity-0');
        content.classList.remove('scale-95');
        content.classList.add('scale-100');
      });
      
      function closeModal() {
        modal.classList.add('opacity-0');
        content.classList.remove('scale-100');
        content.classList.add('scale-95');
        setTimeout(() => {
          document.body.removeChild(modal);
        }, 300);
      }
    }
  };
  dialog.type = 'copy';
  return dialog;
};
